// Dev only
let log = {
    types:{
        info: 'color: #535ded; font-weight: bold;',
        error: 'color: #ff5252; font-weight: bold;'
    },
    info: function (message) {
        console.log('%c --- ' + message, this.types.info);
    },
    error: function (message) {
        console.error('%c --- ' + message, this.types.error);
    }
};

export default log;